export const questThemes = [
  {
    id: 1,
    name: "Pizza Party",
    tasks: [
      { id: 101, text: 'Create a category named "Pizzas"', isComplete: false },
      { id: 102, text: 'Add a dish priced at $12 or more', isComplete: false },
      { id: 103, text: 'Draw a pizza-themed logo', isComplete: false },
      { id: 104, text: "Use the color picker to change the background", isComplete: false },
      { id: 105, text: "Set the restaurant status to Open", isComplete: false },
      // New quests:
      { id: 106, text: "Add a vegetarian pizza dish", isComplete: false },
      { id: 107, text: "Draw a slice of pizza on the canvas", isComplete: false },
    ],
  },
  {
    id: 2,
    name: "Taco Fiesta",
    tasks: [
      { id: 201, text: 'Create a category named "Tacos"', isComplete: false },
      { id: 202, text: 'Draw a taco-themed logo', isComplete: false },
      { id: 203, text: "Add a phone number in the side menu", isComplete: false },
      { id: 204, text: "Use the dish canvas to draw at least one dish", isComplete: false },
      { id: 205, text: "Add a dish named 'Spicy Fiesta'", isComplete: false },
      // New quests:
      { id: 206, text: "Add a vegetarian taco dish", isComplete: false },
      { id: 207, text: "Draw a sombrero on the canvas", isComplete: false },
    ],
  },
  {
    id: 3,
    name: "BBQ Bash",
    tasks: [
      { id: 301, text: 'Create a category named "BBQ"', isComplete: false },
      { id: 302, text: "Add two dishes priced $15 or more each", isComplete: false },
      { id: 303, text: "Draw a grill-themed logo", isComplete: false },
      { id: 304, text: "Set opening hours in the side menu", isComplete: false },
      { id: 305, text: "Use the eraser at least once while drawing a dish", isComplete: false },
      // New quests:
      { id: 306, text: "Add a dish with 'Ribs' in the name", isComplete: false },
      { id: 307, text: "Draw a BBQ sauce bottle", isComplete: false },
    ],
  },
  {
    id: 4,
    name: "Sweet Desserts",
    tasks: [
      { id: 401, text: 'Create a category named "Desserts"', isComplete: false },
      { id: 402, text: 'Add a dish priced at $10 or more', isComplete: false },
      { id: 403, text: 'Draw a dessert-themed logo', isComplete: false },
      { id: 404, text: "Update the phone number field", isComplete: false },
      { id: 405, text: "Provide an order link in the side menu", isComplete: false },
      // New quests:
      { id: 406, text: "Add a chocolate dessert", isComplete: false },
      { id: 407, text: "Draw an ice cream cone", isComplete: false },
    ],
  },
  {
    id: 5,
    name: "Global Cuisine",
    tasks: [
      { id: 501, text: 'Create a category named "World Tour"', isComplete: false },
      { id: 502, text: "Add one dish for each continent", isComplete: false },
      { id: 503, text: "Draw a globe-themed logo", isComplete: false },
      { id: 504, text: "Change the background color twice", isComplete: false },
      { id: 505, text: "Add a directions link in the side menu", isComplete: false },
      // New quests:
      { id: 506, text: "Add a dish with 'Fusion' in the name", isComplete: false },
      { id: 507, text: "Draw a flag from any country", isComplete: false },
    ],
  },
];